import type { ApiUnit } from '@/types/api'

/**
 * Whether a unit is currently within its on-notice (Fair Housing) window.
 *
 * Mirrors the PHP `Unit::is_in_on_notice_window()` rule: the unit must have a
 * positive expiry timestamp and the expiry must not have passed yet.
 */
export function isUnitOnNotice (unit: Pick<ApiUnit, 'on_notice_expiry'>): boolean {
	const expiry = unit.on_notice_expiry ?? 0
	if (expiry <= 0) return false
	return Date.now() / 1000 < expiry
}

/**
 * The "Application Available {date}" tag label shown for on-notice units.
 */
export function onNoticeTagLabel (unit: Pick<ApiUnit, 'on_notice_application_date_string'>): string {
	return `Application Available ${unit.on_notice_application_date_string}`.trim()
}
